

// ------------- old code ----------------------

import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import { all_routes } from '../../router/all_routes'
import CollapseHeader from '../../../core/common/collapse-header/collapse-header'
import PredefinedDateRanges from '../../../core/common/datePicker'
import Table from "../../../core/common/dataTable/index";
// import { leadsDataList } from '../../../core/data/json/leadsList'
// import CrmsModal from '../../../core/modals/crms_modal'
import { leadsDataList } from '../../../core/data/json/leadsList'
import AXIOSCONFIGMETHOD from '../../../Axios/axiosConfigMethod'
import { webServiceUrl } from '../../../core/api_utils/webserviceUrl'
// import { useLocation } from 'react-router-dom';
import '../../../core/common/loader/index';
import Loader from '../../../core/common/loader/index'
import CustomeLoader from '../../../core/common/customeLoader/CustomeLoader'
import Loading from '../../../core/common/custom-loading/Loading'
import dayjs from "dayjs";
const FollowUpTrails = () => {
  const navigate = useNavigate();
  const routes = all_routes;
  // const data = leadsDataList;
  const location = useLocation();
  const lead_id = location.state?.lead_id;
  // console.log(lead_id, "id mila")




  const [followUpTrail, setFollowUpTrail] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedItemId, setSelectedItemId] = useState<any | null>(null);

  // console.log("qqqqqqqqqqqqqqqqqqqqq", followUpTrail)


  const getFollowUpTrailData = async () => {
    setLoading(true);
    try {
      const payload = {
        lead_account_id: lead_id,
      };
      const response = await AXIOSCONFIGMETHOD("post", webServiceUrl.FOLLOWUPTRAILS, payload);
      console.log("arjun second ajsadfafasdf", response?.data)
      if (response?.success === true) {
        // console.log("hello i am in")
        setFollowUpTrail(response?.data);
      } else {
        // setFollowUpTrail([]);
        console.warn("API response error or no data");
      }
    } catch (error) {
      console.error("API call failed:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getFollowUpTrailData();
  }, []);



  const columns = [

  // --- Lead Status / Stage ---
  {
      title: "Current Stage",
      dataIndex: "current_stage",
      render: (text: string) => (
        <span
          className={`badge ${text === 'WON'
            ? 'badge-success-transparent'
            : text === 'FOLLOWUP'
              ? 'badge-warning-transparent'
              : text === 'LOST'
                ? 'badge-danger-transparent'
                : 'badge-secondary-transparent'
            }`}
        >
          {text ?? "-"}
        </span>
      ),
      sorter: (a: any, b: any) => a.current_stage.length - b.current_stage.length,
    },
  {
    title: "Disposition",
    dataIndex: "disposition",
    key: "disposition",
     render:(value:string) => value || "-"
  },

  // --- Timeline / Activity ---
{
  title: "Created On",
  dataIndex: "created_on",
  key: "created_on",
  render: (value: string | undefined) => {
    if (!value) return "-";

    const date = new Date(value);
    if (isNaN(date.getTime())) return "-";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours === 0 ? 12 : hours;

    return (
      <p style={{ margin: 0 }}>{`${day}/${month}/${year}, ${hours}:${minutes} ${ampm}`}</p>
    );
  },
  sorter: (a: { created_on?: string }, b: { created_on?: string }) =>
    new Date(a.created_on || 0).getTime() - new Date(b.created_on || 0).getTime(),
},

  {
    title: "Follow-up Comments",
    dataIndex: "followup_comments",
    key: "followup_comments",
     render:(value:string) => value || "-"
  },

  // --- Meetings (Scheduled) ---
  {
    title: "Scheduled Meeting Date",
    dataIndex: "scheduled_meeting_date",
    key: "scheduled_meeting_date",
     render:(value:string) => value || "-"
  },
  {
    title: "Scheduled Meeting Time",
    dataIndex: "scheduled_meeting_time",
    key: "scheduled_meeting_time",
     render:(value:string) => value || "-"
  },
  {
    title: "Scheduled Meeting Location",
    dataIndex: "scheduled_meeting_location",
    key: "scheduled_meeting_location",
     render:(value:string) => value || "-"
  },



  // --- Next Actions ---
  {
    title: "Next Follow-up Date",
    dataIndex: "next_followup_date",
    key: "next_followup_date",
     render:(value:string) => value || "-"
  },
  {
    title: "Next Follow-up Time",
    dataIndex: "next_followup_time",
    key: "next_followup_time",
     render:(value:string) => value || "-"
  },
      // --- Lead Metadata ---
  // {
  //   title: "Sales Owner",
  //   dataIndex: "sales_owner",
  //   key: "sales_owner",
  //   render:(value:string) => value || "-"
  // },


];


  // const columns = [
  //   {
  //     title: "Lead Name",
  //     dataIndex: "lead_name",
  //     sorter: (a: any, b: any) => a.lead_name.length - b.lead_name.length,
  //   },

  //   {
  //     title: "Mobile Number",
  //     dataIndex: "mobile_no",
  //     sorter: (a: any, b: any) => a.mobile_no.length - b.mobile_no.length,
  //   },
  //   {
  //     title: "Email",
  //     dataIndex: "email_id",
  //     sorter: (a: any, b: any) => a.email_id.length - b.email_id.length,
  //   },
  //   {
  //     title: "City",
  //     dataIndex: "city",
  //     sorter: (a: any, b: any) => a.city.length - b.city.length,
  //   },
  //   {
  //     title: "State",
  //     dataIndex: "state",
  //     sorter: (a: any, b: any) => a.state.length - b.state.length,
  //   },
  //   {
  //     title: "Sales User Id",
  //     dataIndex: "sales_user_id",
  //     sorter: (a: any, b: any) => a.sales_user_id.length - b.sales_user_id.length,
  //   },

  //   {

  //     title: "Sales Owner",
  //     dataIndex: "sales_owner",
  //     sorter: (a: any, b: any) => a.sales_owner.length - b.sales_owner.length,

  //     // title: "Sales Owner",
  //     // dataIndex: "SalesOwner",
  //     // render: (text: string, record: any) => (
  //     //   <div className="d-flex align-items-center file-name-icon">

  //     //     <div className="ms-2">
  //     //       <div className="">
  //     //         <Link to={routes.companiesDetails}>{text}</Link>
  //     //       </div>
  //     //     </div>
  //     //   </div>
  //     // ),
  //     // sorter: (a: any, b: any) => a.SalesOwner.length - b.SalesOwner.length,
  //   },

  //   {
  //     title: "Stage",
  //     dataIndex: "current_stage",
  //     render: (text: string) => (
  //       <span
  //         className={`badge ${text === 'WON'
  //           ? 'badge-success-transparent'
  //           : text === 'FOLLOWUP'
  //             ? 'badge-warning-transparent'
  //             : text === 'LOST'
  //               ? 'badge-danger-transparent'
  //               : 'badge-secondary-transparent'
  //           }`}
  //       >
  //         {text}
  //       </span>
  //     ),
  //     sorter: (a: any, b: any) => a.current_stage.length - b.current_stage.length,
  //   },

  //   {
  //     title: "Action",
  //     dataIndex: "action",
  //     render: (_: any, record: any) => (
  //       <div className="action-icon d-inline-flex">
  //         <Link
  //           to="#"
  //           className="me-2 text-primary"
  //           data-bs-toggle="modal"
  //           data-bs-target="#view_modal" 
  //           title="View Details"
  //           onClick={() => {
  //             console.log(record, "this is my data")
  //             setSelectedItemId(record)
  //           }}

  //         >
  //           <i className="ti ti-eye" />
  //         </Link>
  //         {/* Verified Button */}


  //         {/* False Booking Button */}



  //       </div>
  //     ),
  //   }



  //   //     {
  //   //   title: "Genter",
  //   //   dataIndex: "Gender",
  //   //   sorter: (a: any, b: any) => a.LeadOwner.length - b.LeadOwner.length,
  //   // },
  //   // {
  //   //   title: "Gender",
  //   //   dataIndex: "actions",
  //   //   render: () => (
  //   //     <div className="action-icon d-inline-flex">
  //   //     <Link
  //   //       to="#"
  //   //       className="me-2"
  //   //       data-bs-toggle="modal"
  //   //       data-bs-target="#edit_leads"
  //   //     >
  //   //       <i className="ti ti-edit" />
  //   //     </Link>
  //   //     <Link
  //   //       to="#"
  //   //       data-bs-toggle="modal"
  //   //       data-bs-target="#delete_modal"
  //   //     >
  //   //       <i className="ti ti-trash" />
  //   //     </Link>
  //   //   </div>
  //   //   ),
  //   // },
  // ]
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Follow Up Trails </h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item"> <Link to={routes.leaddashboard}>
                    Dashboard
                  </Link></li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Follow Up Trails
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <button
                onClick={() => {
                  if (window.history.length > 1) {
                    navigate(-1);
                  } else {
                    navigate('/sales-person-lead-list');
                  }
                }}

                className="btn btn-sm me-1"
                style={{ whiteSpace: 'nowrap', background: '#6b7280', color: 'white' }}
              >
                Back
              </button>
              {/* <div className="me-2 mb-2">
                   <div className="dropdown">
                     <Link
                       to="#"
                       className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                       data-bs-toggle="dropdown"
                     >
                       <i className="ti ti-file-export me-1" />
                       Export
                     </Link>
                     <ul className="dropdown-menu  dropdown-menu-end p-3">
                       <li>
                         <Link
                           to="#"
                           className="dropdown-item rounded-1"
                         >
                           <i className="ti ti-file-type-pdf me-1" />
                           Export as PDF
                         </Link>
                       </li>
                       <li>
                         <Link
                           to="#"
                           className="dropdown-item rounded-1"
                         >
                           <i className="ti ti-file-type-xls me-1" />
                           Export as Excel{" "}
                         </Link>
                       </li>
                     </ul>
                   </div>
                 </div> */}
              {/* <div className="input-icon mb-2 position-relative">
                   <PredefinedDateRanges />
                 </div> */}
              <div className="ms-2 head-icons">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Leads List */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5> Follow Up Trails  </h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                {/* <div className="me-3">
              <div className="input-icon-end position-relative">
                <PredefinedDateRanges/>
                <span className="input-icon-addon">
                  <i className="ti ti-chevron-down" />
                </span>
              </div>
            </div> */}
                {/* <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Tags
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Closed
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Contacted
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Lost
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Not Contacted
                      </Link>
                    </li>
                  </ul>
                </div> */}
                {/* <div className="dropdown">
              <Link
                to="#"
                className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Sort By : Last 7 Days
              </Link>
              <ul className="dropdown-menu  dropdown-menu-end p-3">
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                  >
                    Recently Added
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                  >
                    Ascending
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                  >
                    Desending
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                  >
                    Last Month
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                  >
                    Last 7 Days
                  </Link>
                </li>
              </ul>
            </div> */}
              </div>
            </div>
            {
              loading ? (
                <Loading />
              ) : (
                <div className="card-body p-0">
                  <Table dataSource={followUpTrail} columns={columns} Selection={false} />
                </div>
              )
            }
          </div>
          {/* /Leads List */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
          <p className="mb-0">{new Date().getFullYear()} © Nestfin Technology. All rights reserved.</p>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* <CrmsModal/> */}


      {/* open view modal start  */}



      <div
        className="modal fade"
        id="view_modal"
        aria-labelledby="viewModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content rounded-4 shadow-sm">
            <div className="modal-header border-bottom-1 border-light">
              <h5 className="modal-title fw-bold fs-5 text-dark" id="viewModalLabel">
                Follow-up Trail Details
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body px-4 py-3">
              {selectedItemId ? (
                <div className="details-grid">
                  {[
                    ["Lead Account ID", selectedItemId.lead_account_id],
                    ["Lead Name", selectedItemId.lead_name],
                    ["Mobile No", selectedItemId.mobile_no],
                    ["Email ID", selectedItemId.email_id],
                    ["City", selectedItemId.city],
                    ["State", selectedItemId.state],
                    ["Disposition", selectedItemId.disposition],
                    ["Current Stage", selectedItemId.current_stage],
                    ["Follow-up Comments", selectedItemId.followup_comments],
                    ["Created On", selectedItemId.created_on],
                    ["Scheduled Meeting Date", selectedItemId.scheduled_meeting_date || "N/A"],
                    ["Scheduled Meeting Time", selectedItemId.scheduled_meeting_time || "N/A"],
                    ["Scheduled Meeting Location", selectedItemId.scheduled_meeting_location || "N/A"],
                    ["Next Follow-up Date", selectedItemId.next_followup_date || "N/A"],
                    ["Next Follow-up Time", selectedItemId.next_followup_time || "N/A"],
                    ["Sales Owner", selectedItemId.sales_owner || "N/A"],
                    ["Sales User ID", selectedItemId.sales_user_id],
                  ].map(([label, value], i) => (
                    <div key={i} className="detail-item">
                      <span className="detail-label fw-semibold">{label}</span>
                      <span className="detail-value text-dark">{value}</span>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-center text-muted fst-italic">
                  Select a record to see details
                </p>
              )}
            </div>
          </div>
        </div>
      </div>


      {/* <div
        className="modal fade"
        id="view_modal"
        aria-labelledby="viewModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content rounded-4 shadow-sm">
            <div className="modal-header border-bottom-1 border-light">
              <h5 className="modal-title fw-bold fs-5 text-dark" id="viewModalLabel">
                Follow-up Trail Details
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body px-4 py-3">
              {selectedItemId ? (
                <div className="details-grid">
                  {[
                    ["Lead Account ID", selectedItemId.lead_account_id],
                    ["Lead Name", selectedItemId.lead_name],
                    ["Mobile No", selectedItemId.mobile_no],
                    ["Email ID", selectedItemId.email_id],
                    ["City", selectedItemId.city],
                    ["State", selectedItemId.state],
                    ["Disposition", selectedItemId.disposition],
                    ["Current Stage", selectedItemId.current_stage],
                    ["Follow-up Comments", selectedItemId.followup_comments],
                    ["Created On", selectedItemId.created_on],
                    ["Scheduled Meeting Date", selectedItemId.scheduled_meeting_date || "N/A"],
                    ["Scheduled Meeting Time", selectedItemId.scheduled_meeting_time || "N/A"],
                    ["Scheduled Meeting Location", selectedItemId.scheduled_meeting_location || "N/A"],
                    ["Next Follow-up Date", selectedItemId.next_followup_date || "N/A"],
                    ["Next Follow-up Time", selectedItemId.next_followup_time || "N/A"],
                    ["Sales Owner", selectedItemId.sales_owner || "N/A"],
                    ["Sales User ID", selectedItemId.sales_user_id],
                  ].map(([label, value], i) => (
                    <div key={i} className="detail-item">
                      <span className="detail-label fw-semibold">{label}</span>
                      <span className="detail-value text-dark">{value}</span>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-center text-muted fst-italic">
                  Select a record to see details
                </p>
              )}
            </div>
          </div>
        </div>
      </div> */}


      {/* open view modal close  */}



    </>

  )
}

export default FollowUpTrails